/**
 * apiError — module pur (zéro import Supabase / browser runtime).
 *
 * Doctrine 9.K.14 (D58.3-a, fix VPS post-test FAIL) :
 * - `ApiError` (shape payload bilingue ADR 0027 P-3) et `ApiException`
 *   (classe Error wrap) sont définis ici, **sans** dépendance à `supabase.ts`
 *   ni à `window.localStorage`. Cela rend le helper `apiErrorMessage.ts`
 *   et son test unitaire exécutables en environnement Node pur (vitest)
 *   sans avoir à forcer un environnement jsdom.
 * - `apps/web/src/lib/api.ts` ré-exporte `ApiError` et `ApiException` depuis
 *   ce module pour préserver la compatibilité des imports existants
 *   (`import { ApiException } from "./api"` ou `"@/lib/api"`).
 * - `apps/web/src/lib/apiErrorMessage.ts` importe `ApiException` depuis
 *   ce module pur, pas depuis `api.ts`.
 *
 * Ne rien ajouter ici qui touche fetch, JWT, Supabase, window, localStorage.
 */

export type ApiError = {
  code: string;
  /**
   * Alias rétrocompat — chaîne FR par défaut côté API.
   * Conservé pour les payloads legacy non migrés et pour `Error.message`.
   * Sera retiré en chunk ultérieur (post-D58.3 + post-D58.1 MCP/tools).
   */
  message: string;
  /**
   * Payload bilingue self-contained (ADR 0027 P-3, chunk 9.K.6→9.K.13).
   * Optionnel pour rétrocompat — absent sur les payloads legacy.
   * Côté UI, consommé via `getApiErrorMessage(err, lang)` (cf.
   * `apiErrorMessage.ts`).
   */
  messages?: { en: string; fr: string };
  details?: unknown;
  request_id?: string;
};

export class ApiException extends Error {
  constructor(
    public readonly status: number,
    public readonly apiError: ApiError,
  ) {
    super(apiError.message);
  }
}
